// src/swRegistration.js

export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          console.log('ServiceWorker registered successfully: ', registration.scope);
          
          // Check for updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            console.log('Service Worker update found!');
            
            newWorker.addEventListener('statechange', () => {
              console.log('Service Worker state changed:', newWorker.state);
            });
          });
          
          // Set up message listener for service worker requests
          if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.addEventListener('message', (event) => {
              if (event.data && event.data.type === 'GET_FEES_DATA') {
                // Get fees from localStorage
                const fees = localStorage.getItem('fees') || localStorage.getItem('user_fees') || 0;
                
                // Send response back to service worker
                if (navigator.serviceWorker.controller) {
                  navigator.serviceWorker.controller.postMessage({
                    type: 'FEES_DATA',
                    fees: parseFloat(fees)
                  });
                }
              }
            });
          } else {
            // If controller is not available, set up after controller is ready
            navigator.serviceWorker.ready.then((registration) => {
              if (registration.active) {
                registration.active.addEventListener('message', (event) => {
                  if (event.data && event.data.type === 'GET_FEES_DATA') {
                    const fees = localStorage.getItem('fees') || localStorage.getItem('user_fees') || 0;
                    if (registration.active) {
                      registration.active.postMessage({
                        type: 'FEES_DATA',
                        fees: parseFloat(fees)
                      });
                    }
                  }
                });
              }
            });
          }
        })
        .catch((error) => {
          console.log('ServiceWorker registration failed: ', error);
        });
    });
  }
}

// Helper function to update fees and trigger notification
export function updateFeesAndNotify(amount) {
  localStorage.setItem('fees', amount);
  
  // Trigger notification check
  if (window.checkFeeNotification) {
    window.checkFeeNotification();
  }
  
  // Also try to notify through service worker
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'FEES_DATA',
      fees: parseFloat(amount)
    });
  }
}